import axios from 'axios'

// initial state
const state = {
  user: {}
}

// getters
const getters = {
  user: (state) => {
    return state.user.data
  },

  userPermissions: (state) => {
    var permissions = []
    state.user.data.roles.forEach(role => {
      role.permissions.forEach(permission => {
        permissions.push(permission.name)
      })
    })
    return permissions
  },

  hasPermission: (state, getters) => (permission) => {
    var hasRole = false
    getters.userPermissions.forEach(userPermission => {
      if (userPermission === permission) {
        hasRole = true
      }
    })
    return hasRole
  }
}

// actions
const actions = {
  getUser ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/user`, {
        params: {
          with: ['roles.permissions']
        }
      })
        .then(response => {
          commit('setUser', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updateUser ({ commit }, obj) {
    return new Promise((resolve) => {
      commit('setUser', obj)
      resolve()
    })
  },

  clearUser ({ commit }) {
    commit('clearUser')
  }
}

// mutations
const mutations = {
  setUser (state, user) {
    state.user = user
  },

  clearUser (state) {
    state.user = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
